<script setup lang="ts">
import WalletsDirectoryContainer from './containers/WalletsDirectoryContainer.vue'
</script>

<template>
  <WalletsDirectoryContainer />
</template>
